import React, { useState } from "react";
import StdButton from "componentsv2/button/Button";
import { Section } from "./layout/Sections";
import { buttonColors, buttonOutlineColors } from "theme/theme";
import Codeblock from "./components/CodeBlock";

const MenuBUttons = () => {
  const [showOutline, setShowOutline] = useState(false);
  const [search, setSearch] = useState("");
  const colorsToShow = showOutline ? buttonOutlineColors : buttonColors;
  const colorNames = Object.keys(colorsToShow);
  const filteredColors = colorNames.filter((name) =>
    name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <>
      {/* Sección de búsqueda y controles */}
      <div className="mb-6 max-w-4xl mx-auto p-5 bg-gray-100 rounded-lg shadow-md flex  items-center space-x-5 justify-between">
        <input
          type="text"
          placeholder="Buscar color..."
          className="w-[60%] p-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring focus:border-blue-300 bg-white"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="w-fit font-normal text-base text-gray-500 flex items-center gap-2">
          <span className="bold text-green-900">{filteredColors.length}</span>{" "}
          Colores disponibles
          <label className="relative inline-flex items-center cursor-pointer ml-4">
            <span className="mr-2 text-sm text-gray-600">Contorno</span>

            <div className="relative">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={showOutline}
                onChange={() => setShowOutline(!showOutline)}
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </div>
          </label>
        </div>
      </div>
      <Section title="Documentación de Colores de StdButton">
        <div className="container mx-auto py-3">
          {/* Cuadrícula de botones de colores */}
          <div>
            <Codeblock>
              {`<StdButton color="blue" noFill={showOutline} size="w-full" />`}
            </Codeblock>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {filteredColors.length > 0 ? (
              filteredColors.map((colorName) => (
                <div
                  key={colorName}
                  className="flex flex-col items-center p-4 rounded-lg border border-gray-200 bg-white"
                >
                  <span className="mb-4 text-sm font-semibold text-gray-600">
                    `color="${colorName}"`
                  </span>
                  <StdButton
                    color={colorName}
                    noFill={showOutline}
                    size="w-full"
                  >
                    {colorName.charAt(0).toUpperCase() + colorName.slice(1)}
                  </StdButton>
                </div>
              ))
            ) : (
              <div className="col-span-full text-center text-gray-500">
                No se encontraron colores.
              </div>
            )}
          </div>
        </div>
      </Section>
      {/* <Section title="Tamaños">
        <div className="p-6">
          <button
            onClick={() => setVisible(!visible)}
            className="mb-4 px-4 py-2 bg-blue-600 text-white rounded"
          >
            Toggle
          </button>

          <div
            className={`transition-opacity duration-700 ${
              visible ? "opacity-100" : "opacity-0"
            }`}
          >
            <p className="bg-gray-200 p-4 rounded">
              Este texto aparece y desaparece
            </p>
          </div>
        </div>
      </Section> */}
    </>
  );
};

export default MenuBUttons;
